import env from "./envConfig";

export const apiConfig = {
	baseURL: env.REACT_APP_SERVICE_URL,
	frameworkURL: env.REACT_APP_SERVICE_URL_FRAMEWORK,
	maestroURL: env.REACT_APP_SERVICE_URL_MAESTRO,
	baseApiURL: `${env.REACT_APP_SERVICE_URL}/api`,
	apiUriVersion: env.REACT_APP_API_VERSION,
};
